const shadow = {
  default: '0 13px 27px -5px hsla(240, 30.1%, 28%, 0.25), 0 8px 16px -8px hsla(0, 0%, 0%, 0.3), 0 -6px 16px -6px hsla(0, 0%, 0%, 0.03)',
  light: '0 30px 60px rgba(255,255,255,0.9)',
  medium: '4px 12px 40px 6px rgba(0,0,0,0.09)',
  dark: '4px 12px 40px 6px rgba(0,0,0,0.18)',
}

export default shadow;
export {shadow}
